import { render } from "./LanguagueSwitch.vue?vue&type=template&id=2279cbe0"
import script from "./LanguagueSwitch.vue?vue&type=script&lang=ts"
export * from "./LanguagueSwitch.vue?vue&type=script&lang=ts"

import "./LanguagueSwitch.vue?vue&type=style&index=0&id=2279cbe0&lang=scss"
script.render = render

export default script